import React, { useEffect } from 'react'
import { ToastTypes, launchToast } from '../../components'
import { WemoloLoading, WemoloTypography } from '../../components/Wemolo'
import { setTabTitle } from '../../utils'
import { MLPProvider } from './MLPContext'
import { MLPResult } from './MLPStore'
import { MLPView } from './MLPView'
import { processMLPData, useGetPotentialMlpsQuery, usePushCheckedMlpsMutation } from './utils'
import styles from './MLPContainer.module.css'

export const MLPContainer = () => {
    const [fullyFetchedCases, setFullyFetchedCases] = React.useState<unknown[]>([])
    const [areAllCasesFetched, setAreAllCasesFetched] = React.useState<boolean>(false)
    const [lowerTimestamp, setLowerTimestamp] = React.useState<string>('')
    const { data } = useGetPotentialMlpsQuery({ lower_timestamp_threshold: lowerTimestamp })
    const { pushCheckedMlps, loading: loadingPushCheckedMlps } = usePushCheckedMlpsMutation()

    useEffect(() => {
        setTabTitle('MLP')
    }, [])
    useEffect(() => {
        if (!data) return

        const potentialMlps = (data.potential_mlps ?? []) as unknown[]
        if (potentialMlps.length > 0) {
            setFullyFetchedCases((prevCases) => [...prevCases, ...potentialMlps])
        }
        if (data.latest_timestamp) {
            setLowerTimestamp(data.latest_timestamp)
        } else {
            setAreAllCasesFetched(true)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [data])

    const pushCheckedMlpsHandler = async (results: MLPResult[], callBack: () => void) => {
        try {
            const res = await pushCheckedMlps({ checked_mlps: results })
            if (res.errors) {
                launchToast(ToastTypes.Error, 'Error: Batch could not be submitted.Refresh the page and try again!')
                return
            }
            launchToast(ToastTypes.Success, 'Batch submitted successfully !')
            callBack()
        } catch {
            // hook already toasted + reported to Sentry
        }
    }

    if (areAllCasesFetched) {
        return (
            <MLPProvider
                context={{
                    mlpBatches: processMLPData(fullyFetchedCases as Parameters<typeof processMLPData>[0]),
                    pushCheckedMlpsHandler,
                    loadingPushCheckedMlps
                }}
            >
                <MLPView />
            </MLPProvider>
        )
    } else {
        return (
            <div className={styles.loadingWrapper}>
                <WemoloTypography variant="title-xsmall" tag="span">
                    Loading...
                </WemoloTypography>
                <WemoloLoading />
            </div>
        )
    }
}
